import React from "react"
import moment from "moment"
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './birthdate.css'

const CustomInput = React.forwardRef((prop, ref) => (
  <div className="custom-datepicker-input">
    <input
      type="text"
      value={prop.value}
      onClick={prop.onClick}
      readOnly
      ref={ref}
      className={`input is-medium ${prop.basicErrors.birthDate ? 'birth-date-error' : ''}`}
      placeholder='Birth Date'
    />
    <span className="icon is-medium is-left">
      <i className="fal fa-calendar" aria-hidden="true"></i>
    </span>
  </div>
))

const CustomDateOfBirthPicker = (props) => {
  const { basicValues, basicErrors } = props
  return (
    <div className="field">
      <DatePicker
        name="birth_date"
        id="birth_date"
        selected={basicValues.birthDate ? moment(basicValues.birthDate).toDate() : null}
        onChange={(date) => props.onChange('birthDate', date ? moment(date).format('YYYY-MM-DD') : '')}
        dateFormat="yyy-MM-dd"
        showYearDropdown={true}
        showMonthDropdown={true}
        showPopperArrow={false}
        dropdownMode='select'
        customInput={<CustomInput basicErrors={basicErrors}/>}
        style={{ overflow: 'visible' }}
        maxDate={new Date()}
      />
      {basicErrors.birthDate && (
        <div
          className="has-text-danger mt-2 is-size-7"
        >
          {basicErrors.birthDate}
        </div>
      )}
    </div>
  )
}

export default CustomDateOfBirthPicker